import { render, staticRenderFns } from "./ClassToOpen.vue?vue&type=template&id=10cab52a"
import script from "./ClassToOpen.vue?vue&type=script&lang=js"
export * from "./ClassToOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports